import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import { clearOfflineGoldPurchase, fetchSubscriptionReport } from "../../../../store/actions/report/ReportsAction";
import NoDataFound from "../../common/NoDataFound";
import Styles from "./SubscriptionReport.module.css";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { convertToISTDate } from "../../../../utils/DateTime.service";

const SubscriptionReport = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(moment().subtract(7, "days"));
  const [endDate, setEndDate] = useState(moment());
  const itemsPerPage = Number(process.env.REACT_APP_ITEMS_PER_PAGE);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const payload = {
      // start_date: startDate.format("YYYY-MM-DD"),
      // end_date: endDate.format("YYYY-MM-DD"),
      start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      end_date: endDate ? endDate.format("YYYY-MM-DD") : "",
    };
    dispatch(fetchSubscriptionReport(payload, navigate));
  }, [dispatch, navigate]);

  const { subscription, loading } = useSelector((state) => state.reports);

  const totalPages = subscription && Math.ceil(subscription.length / itemsPerPage);

  // Toast default options
  const defaultOptions = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true,
    theme: "colored",
  };

  const handleGo = () => {
    if (!startDate || !endDate) {
      toast.error("Please select both start and end dates.", defaultOptions);
      return;
    }
    const payload = {
      start_date: startDate.format("YYYY-MM-DD"),
      end_date: endDate.format("YYYY-MM-DD"),
    };
    dispatch(fetchSubscriptionReport(payload, navigate));
  };

  const onFormReset = () => {
    // const newStartDate = moment().subtract(7, "days");
    // const newEndDate = moment();
    // setStartDate(newStartDate);
    // setEndDate(newEndDate);
    // setCurrentPage(1);
    // const payload = {
    //   start_date: newStartDate.format("YYYY-MM-DD"),
    //   end_date: newEndDate.format("YYYY-MM-DD"),
    // };
    // dispatch(fetchSubscriptionReport(payload, navigate));
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
    dispatch(clearOfflineGoldPurchase());
  };

  const onPageChange = (increment) => {
    setCurrentPage((prevPage) => Math.max(1, Math.min(prevPage + increment, totalPages)));
  };

  const handleDownload = () => {
    if (subscription.length === 0) {
      toast.info("No data available for download!", defaultOptions);
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      subscription.map((item) => ({
        "Customer ID": item.id || "--",
        Phone: item.phone || "--",
        Status: item.status || "--",
        "Subscription Start Date": convertToISTDate(item.start_date) || "--",
        "Subscription End Date": convertToISTDate(item.end_date) || "--",
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscription Report");
    XLSX.writeFile(workbook, `Subscription Report${moment().format("YYYY-MM-DD")}.xlsx`);
  };

  // Get current items for the current page
  const currentItems = subscription.length > 0 && subscription.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <div className='row page-titles'>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item active'>
            <Link to={"#"}>Reports</Link>
          </li>
        </ol>
      </div>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-header d-flex justify-content-between align-items-center'>
              <h4 className='card-title mb-0'>Subscription Report</h4>
              <div className='d-flex align-items-center justify-content-end'>
                <div className='d-flex flex-column mx-1 w-25'>
                  <div className='ms-2'>From:</div>
                  {/* <DatePicker selected={startDate.toDate()} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate.toDate()} /> */}
                  <DatePicker selected={startDate ? startDate.toDate() : null} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate ? endDate.toDate() : null} onKeyDown={(e) => e.preventDefault()} />
                </div>
                <div className='d-flex flex-column mx-1 w-25'>
                  <div className='ms-2'>To:</div>
                  {/* <DatePicker selected={endDate.toDate()} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate.toDate()} maxDate={moment().toDate()} /> */}
                  <DatePicker selected={endDate ? endDate.toDate() : null} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate ? startDate.toDate() : null} maxDate={moment().toDate()} onKeyDown={(e) => e.preventDefault()} />
                </div>
                <div className='d-flex mt-3'>
                  <button className='btn btn-primary mx-1' type='button' onClick={handleGo}>
                    Go
                  </button>
                  <button className='btn btn-outline-secondary mx-1' type='button' onClick={onFormReset}>
                    Clear
                  </button>
                  <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
                    Download
                  </button>
                </div>
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive ticket-table'>
                <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
                  <div className='table-responsive'>
                    <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
                      <thead>
                        <tr>
                          <th>Customer ID</th>
                          <th>Phone</th>
                          <th>Status</th>
                          <th className='text-center'>Subscription Start Date</th>
                          <th className='text-center'>Subscription End Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={5} className='text-center'>
                              <ShimmerLoader width='95%' height='20%' count={3} />
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <Link className={`${Styles.link}`} to={`/view-customer-details/${item.id}`}>
                                  {item.id || "--"}
                                </Link>
                              </td>
                              <td>{item.phone ? item.phone : "--"}</td>
                              <td>{item.status ? item.status : "--"}</td>
                              <td className='text-center'>{item.start_date ? convertToISTDate(item.start_date) : "--"}</td>
                              <td className='text-center'>{item.end_date ? convertToISTDate(item.end_date) : "--"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr className={`${Styles.no_hover}`}>
                            <td className={`fs-3 text-center`} colSpan={5}>
                              <NoDataFound width={450} />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {subscription.length > 0 && (
                    <div className='d-flex justify-content-end align-items-center px-4 py-2'>
                      <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
                        <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
                        <span className='mx-2'>
                          Page {currentPage} of {totalPages}
                        </span>
                        <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // return (
  //   <>
  //     <div className='row page-titles'>
  //       <ol className='breadcrumb'>
  //         <li className='breadcrumb-item active'>
  //           <Link to={"#"}>Reports</Link>
  //         </li>
  //       </ol>
  //     </div>
  //     {loading && <ShimmerLoader width='95%' height='20%' count={4} />}
  //     {!loading && (
  //       <div className='row'>
  //         <div className='col-lg-12'>
  //           <div className='card'>
  //             <div className='card-header d-flex justify-content-between align-items-center'>
  //               <h4 className='card-title mb-0'>Subscription Report</h4>
  //               <div className='d-flex align-items-center justify-content-end'>
  //                 <div className='d-flex flex-column  mx-1 w-25'>
  //                   <div className='ms-2'>From:</div>
  //                   <DatePicker selected={startDate.toDate()} onChange={(date) => setStartDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' maxDate={endDate.toDate()} />
  //                 </div>
  //                 <div className='d-flex flex-column mx-1 w-25'>
  //                   <div className='ms-2'>To:</div>
  //                   <DatePicker selected={endDate.toDate()} onChange={(date) => setEndDate(moment(date))} dateFormat='dd-MM-yyyy' className='form-control mx-1' minDate={startDate.toDate()} maxDate={moment().toDate()} />
  //                 </div>
  //                 <div className="'d-flex mt-3">
  //                   <button className='btn btn-primary mx-1' type='button' onClick={handleGo}>
  //                     Go
  //                   </button>
  //                   <button className='btn btn btn-outline-secondary mx-1' type='button' onClick={onFormReset}>
  //                     Clear
  //                   </button>
  //                   <button className='btn btn-outline-secondary mx-1' type='button' onClick={handleDownload}>
  //                     Download
  //                   </button>
  //                 </div>
  //               </div>
  //             </div>
  //             <div className='card-body'>
  //               <div className='table-responsive ticket-table'>
  //                 <div id='ticket_wrapper' className='dataTables_wrapper no-footer'>
  //                   <div className='table-responsive'>
  //                     <table className='display dataTablesCard table-responsive-xl dataTable no-footer w-100'>
  //                       <thead>
  //                         <tr>
  //                           <th>Customer ID</th>
  //                           <th>Phone</th>
  //                           <th>Status</th>
  //                           <th>Subscription Start Date</th>
  //                           <th>Subscription End Date</th>
  //                         </tr>
  //                       </thead>
  //                       <tbody>
  //                         {currentItems.length > 0 ? (
  //                           currentItems.map((item, index) => (
  //                             <tr key={index}>
  //                               <td>{item.id ? item.id : "--"}</td>
  //                               <td>{item.phone ? item.phone : "--"}</td>
  //                               <td>{item.status ? item.status : "--"}</td>
  //                               <td>{item.start_date ? convertToISTDate(item.start_date) : "--"}</td>
  //                               <td>{item.end_date ? convertToISTDate(item.end_date) : "--"}</td>
  //                             </tr>
  //                           ))
  //                         ) : (
  //                           <tr className={`${Styles.no_hover}`}>
  //                             <td className={`fs-3 text-center`} colSpan={7}>
  //                               <NoDataFound width={450} />
  //                             </td>
  //                           </tr>
  //                         )}
  //                       </tbody>
  //                     </table>
  //                   </div>
  //                   {subscription.length > 0 && (
  //                     <div className='d-flex justify-content-end align-items-center px-4 py-2'>
  //                       <div className='dataTables_paginate paging_simple_numbers mb-0 d-flex align-items-center'>
  //                         <i className={`fa fa-chevron-circle-left fa-2x ${currentPage === 1 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(-1)} style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}></i>
  //                         <span className='mx-2'>
  //                           Page {currentPage} of {totalPages}
  //                         </span>
  //                         <i className={`fa fa-chevron-circle-right fa-2x ${currentPage === totalPages || totalPages === 0 ? "text-muted" : "text-primary"}`} onClick={() => onPageChange(1)} style={{ cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer" }}></i>
  //                       </div>
  //                     </div>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
};

export default SubscriptionReport;
